import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Switch from 'react-switch';

import DesignEditorPrimaryControlButton from '../../../../../DesignEditor/components/DesignEditorControls/components/DesignEditorPrimaryControlButton';
import TripleColumnGridIcon from '../../../../../../icons/TripleColumnGridIcon';

const propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

const CardDesignerGridControlsButton = ({ className, onClick, active }) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControlButton
      className={classes}
      icon={<TripleColumnGridIcon />}
      addon={
        <Switch
          id="grid-enabled"
          className="mt-1"
          uncheckedIcon={false}
          checkedIcon={false}
          height={24}
          width={40}
          onColor="#7ace21"
          offColor="#cdd6e4"
          onChange={() => {}}
          checked={active}
        />
      }
      title="Show grid"
      onClick={onClick}
    />
  );
};

CardDesignerGridControlsButton.propTypes = propTypes;

export default CardDesignerGridControlsButton;
